import React, { useCallback, useState, useEffect } from "react";
import ComplianceNavigatorBaseTable from "./ComplianceNavigatorBaseTable";
import useColumn from "../../../utils/customHooks/useColumns";
import usePageState from "../../../utils/customHooks/usePageState";
import PropTypes from "prop-types";
import UploadFileJourneyWorkerCert from "./UploadFileJourneyWorkerCert";
import { JOURNEY_WORKER_CERTIFICATION_DETAIL, COMPLIANCE_DOCUMENT_DETAIL_SUMMARIES } from "../../../utils/services/apiPath";
//insert JOurneyWorker Api
import { STAUTES } from "../../../utils/constant";
import { getApi } from "../../../utils/services";
import { createODataQuery } from "../../../utils/services/oData";
import { errorToast } from "../../../utils/toastHelper";
import { DateCell } from "../ProGrid/components/FormatCell";
import { IconButton } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { handleDownload } from "../../../utils/fileDownload";

const JourneyWorkerCertification = ({ tableKey, projectId, partnerId }) => {
  const {
    currentPage,
    pageSize,
    data,
    rowCount,
    status,
    sortModel,
    searchString,
    setPageState,
    setPagination,
    setStatus,
    setSortModel,
    setSearchString
  } = usePageState();
  const [insightSummary, setInsightSummary] = useState([]);

  const columns = useColumn([
    {
      field: "projectName",
      headerName: "Project Name"
    },
    {
      field: "partnerName",
      headerName: "Partner"
    },
    {
      field: "employeeName",
      headerName: "Journey Worker Name"
    },
    {
      field: "journeyWorkerCertificationGuid",
      headerName: "Actions",
      width: 160,
      renderCell: params => (
        <>
            <IconButton onClick={() => handleDownload(params.row.documentMediaModel?.path)} color="primary">
              <FileDownloadIcon fontSize="small" />
            </IconButton>
        </>
      )
    }
  ], true);

  const getDetailData = useCallback(async () => {
    setStatus(STAUTES.LOADING);
    const searchableFields = ["projectName", "partnerName", "employeeName"];
    const { data, totalRecords, error } = await getApi(
        //JOurneyWorker API
      `${JOURNEY_WORKER_CERTIFICATION_DETAIL}${createODataQuery(
        searchableFields,
        [],
        "",
        searchString,
        sortModel,
        pageSize,
        currentPage
      )}&projectId=${projectId}&partnerId=${partnerId}`
    );
    setStatus(STAUTES.IDLE);
    if (error) return errorToast(error);
    setPageState(prevPageInfo => ({ ...prevPageInfo, data: data || [], rowCount: totalRecords }));
  }, [currentPage, pageSize, sortModel, searchString, setPageState, setStatus]);

  const fetchInsightData = async () => {
    const res = await getApi(`${COMPLIANCE_DOCUMENT_DETAIL_SUMMARIES}?key=${tableKey}&projectId=${projectId}&partnerId=${partnerId}`);
    setInsightSummary(res);
  };

  useEffect(() => {
    getDetailData();
    fetchInsightData();
  }, [getDetailData]);

  return (
    <ComplianceNavigatorBaseTable
      columns={columns}
      title="Journey Worker Certification Table"
      rows={data}
      insightData={insightSummary}
      tableKey={tableKey}
      rowCount={rowCount}
      status={status}
      setPagination={setPagination}
      setSortModel={setSortModel}
      searchString={searchString}
      setSearchString={setSearchString}
      getRowId={row => row.journeyWorkerCertificationFormGuid}
      pageSize={pageSize}
      currentPage={currentPage}
      uploadPopUp={<UploadFileJourneyWorkerCert title="Journey Worker Certification - File Upload" getDetailData={getDetailData} fetchInsightData={fetchInsightData} />}
    />
  );
};

JourneyWorkerCertification.propTypes = {
  tableKey: PropTypes.string.isRequired
};

export default JourneyWorkerCertification ;